export { default } from './jssPreset';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/jssPreset/index.js
// module id = 577
// module chunks = 2